const header = {
  init() {
    this.$header = document.getElementById('ppc_header')
      ? document.getElementById('ppc_header')
      : document.getElementById('main_header');

    if (this.$header) {
      console.log('Header init');
      this.setUpListeners();
      // this.initializeIntroAnimations();
    }
  },

  setUpListeners() {
    const $menuCover = document.querySelector('.menu_cover');

    if (this.$header.classList.contains('main_header')) {
      PubSub.subscribe(
        'header.updateMenuItems',
        this.updateMenuItems.bind(this)
      );
      PubSub.subscribe(
        'header.show',
        this.showHeader.bind(this)
      );
      PubSub.subscribe(
        'header.hide',
        this.hideHeader.bind(this)
      );
      PubSub.subscribe(
        'header.closeMenu',
        () => {
          const $menuWrapper = this.$header.querySelector('.menu');
          const $submenu = $menuWrapper.querySelector('.sub-menu');

          $menuWrapper.classList.remove('active');
          $submenu.style.height = '0px';

          this.toggleMobileMenu(false);
        }
      );

      this.$header
        .querySelector('.mobile_toggler')
        .addEventListener('click', this.toggleMobileMenu.bind(this));


      this.$header
        .querySelectorAll('.search_toggler')
        .forEach($toggler => {
          $toggler.addEventListener('click', () => {
            PubSub.publish('search.modal.open');
          });
        });

      this.$header
        .querySelectorAll('.menu > .menu-item-has-children > a')
        .forEach($item => {
          $item.addEventListener('click', this.toggleSubMenu.bind(this));
        });

      if (window.innerWidth >= 768) {
        this.$header.addEventListener('mouseenter', () => $menuCover.classList.add('active'));
        this.$header.addEventListener('mouseleave', () => {
          $menuCover.classList.remove('active');
        });
      }
    } else if (this.$header.classList.contains('ppc_header')) {
      this.$header
        .querySelector('a.contact')
        .addEventListener('click', (ev) => {
          const $form = document.querySelector('section.contact_us_block');

          if ($form) {
            ev.preventDefault();
            $form.scrollIntoView({behavior: 'smooth', block: 'start'});
          }
        });
    }

    window.addEventListener('scroll', this.scrollHandler.bind(this));

    // move to the back of the queue and trigger it
    setTimeout(() => {
      if (!this.$header.classList.contains('hidden')) {
        PubSub.publish('toc:offset', true);
      }
    }, 10);
  },

  initializeIntroAnimations() {
    const tl = gsap.timeline({});
    const totalDur = 1.2;
    const $headerParts = document.querySelectorAll(
      '#main_header > .top_wrapper, #main_header > .menu, #ppc_header > .inner_wrapper'
    );

    tl.to($headerParts, {
      opacity: 1.0,
      y: 0,
      duration: totalDur,
      ease: 'homeIntroEase'
    }, 0);
  },

  toggleMobileMenu(newState) {
    let state = !this.$header.classList.contains('active');

    if (newState === true || newState === false) {
      state = newState;
    }

    this.$header.classList.toggle('active', state);
  },

  toggleSubMenu(ev) {
    ev.currentTarget.closest('.menu-item').classList.toggle('active');

    ev.preventDefault();
  },

  updateMenuItems(ev, $newHeader) {
    // if (this.$header.classList.contains('transparent') !== $newHeader.classList.contains('transparent')) {
    //   this.$header.classList.toggle('transparent');
    // }
  },

  prevTop: 0,
  hideDelay: 5,
  currHideDelay: 0,
  showDelay: 10,
  currShowDelay: 0,
  scrollHandler() {
    const currTop = document.documentElement.scrollTop;
    let isCompact = this.$header.classList.contains('compact');
    const isVisible = !this.$header.classList.contains('hidden');
    let hideTopThreshold = window.innerWidth <= 768 ? (0.43 * window.innerWidth) : (0.11 * window.innerWidth);

    if (this.$ppcHeader) {
      hideTopThreshold = 0;
    }

    if (currTop <= hideTopThreshold) {
      if (this.$header.classList.contains('compact')) {
        this.$header.classList.remove('compact');
      }

      if (!isVisible) {
        this.showHeader();
      }
    } else {
      if (!isCompact) {
        this.$header.classList.add('compact');
        isCompact = true;
      }

      // hide on scroll down
      if (currTop < this.prevTop && !isVisible && isCompact) {
        if (this.currShowDelay >= this.showDelay) {
          this.showHeader();
          this.currShowDelay = 0;
        } else {
          this.currShowDelay++;
        }
      } else if (currTop > this.prevTop && isVisible && isCompact) {
        if (this.currHideDelay >= this.hideDelay) {
          this.hideHeader();
          this.currHideDelay = 0;
        } else {
          this.currHideDelay++;
        }
      }
    }

    this.prevTop = currTop;
  },

  showHeader() {
    this.$header.classList.remove('hidden');

    PubSub.publish('toc:offset', true);
  },

  hideHeader() {
    this.$header.classList.add('hidden');

    PubSub.publish('toc:offset', false);
  }
};


export default header;
